import script from "./NotificacionesBell.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificacionesBell.vue?vue&type=script&setup=true&lang=js"

import "./NotificacionesBell.vue?vue&type=style&index=0&id=50728ee0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50728ee0"]])

export default __exports__